module.exports = __webpack_public_path__ + "img/cns_printer_mac23.82ea6084.png";